import React, {Fragment, useState} from 'react';
import {Grid} from "@mui/material";
import ReactPaginate from "react-paginate";
import {useSelector, useDispatch} from "react-redux";
import {proactiveActions} from "_actions";
import {ProactiveMessageList} from "../ProactiveMessageList";
import ProactiveMetricsConversation from "../ProactiveMetricsConversation";
import ConversationCarousel from "../../Vote/Sections/BodySection/Conversation/ConversationCarousel";
import {
    isOEmbedSupported
} from "../../Vote/Sections/BodySection/Conversation/OEmbed/EmbedUtils";
import _ from "lodash";
import SortMenu from '../Utilities/SortMenu';
import styles from "../Utilities/styles.module.css"
import {ACQUIRE_CAMPAIGNS} from "../../RetainDashboard/Utilities/CampaignUtils";

export const ProactiveMessagesBox = ({
     source,
     organizationId,
     messageList,
     allMessagesCount,
     eachPageMessagesCount,
     selectedCheckboxes,
     pageParams,
     setPageParams,
     loading,
     onSortChange,
     orderBy,
     sortBy,
     pageFilter,
     channel
}) => {
    const proactive = useSelector((state) => state.proactive)
    const conversationThread = useSelector((state) => proactive.proactiveMsgConversation)
    const proactiveMsgSocialEngagement = useSelector((state) => proactive.proactiveMsgSocialEngagement)
    const loadingConversation = proactive.loadingProactiveMsgConversation;
    const dispatch = useDispatch();
    const [messageLink, setMessageLink] = useState("");
    const [messageSource, setMessageSource] = useState("");

    const handlePageSelect = (page) => {
        if (conversationThread?.length > 0) {
            dispatch(proactiveActions.clearConversation())
        }
        setPageParams({offset: parseInt(page.selected,10) * 10, currentPage: parseInt(page.selected, 10)})
    }
    const getNextPage = () => {
        const queryOffset = parseInt(pageParams.offset, 10);
        const queryMax = parseInt('10', 10);
        eachPageMessagesCount = parseInt(eachPageMessagesCount, 10)

        if (!eachPageMessagesCount) return 0;

        if ([0, 10, 20, 30, 40, 50, 60, 70, 80, 90].includes(queryOffset) && eachPageMessagesCount === 10) {
            return eachPageMessagesCount + 1;
        } else if (eachPageMessagesCount / queryMax === 1) {
            return (queryOffset / eachPageMessagesCount) + 2;
        } else if (eachPageMessagesCount / queryMax < 1) {
            return (queryOffset / queryMax) + 1;
        } else {
            return 100 // fallback
        }
    };

    const totalPages = getNextPage();
    const messageCountStart = pageParams.offset + 1;
    const totalMsgsCount = allMessagesCount
    const messageCountEnd = pageParams.offset + eachPageMessagesCount
    const conversationItem = conversationThread?.length > 0 && conversationThread[0] || {};
    let {msgSource, displayInApp} = conversationItem;
    msgSource = _.toString(msgSource).toLowerCase();
    const showCarousel = isOEmbedSupported(msgSource, displayInApp);

    function Content() {
        const firstIncomingIndex = conversationThread?.length > 0 && conversationThread?.findIndex(conversationThread => conversationThread.direction === 'INCOMING');
        const firstOutgoingIndex = conversationThread?.length > 0 && conversationThread?.findIndex(conversationThread => conversationThread.direction === 'OUTGOING');

        return(
            conversationThread?.length > 0 && conversationThread.map((conversation, index) =>
                <ProactiveMetricsConversation
                    key={_.get(conversation, 'id')}
                    message={conversation}
                    loadingConversation={loadingConversation}
                    index={index}
                    messageSource={messageSource}
                    isFirstIncomingMessaging={index === firstIncomingIndex}
                    isFirstOutgoingMessaging={index === firstOutgoingIndex}
                    source={source}
                    proactiveMsgSocialEngagement={proactiveMsgSocialEngagement}
                />
            )
        )
    }

    return(
        <Fragment>
            <div className={styles.msgBoxRootWrapper}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={5} lg={5} style={{ width: '543px'}}>
                        <div style={{
                            height: 'calc(100vh - 70px)',
                            borderRight: '1px solid #CED2D0',
                        }}>
                            <div style={{
                                width: '100%',
                                height: '72px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '25px',
                                border: '0.5px solid #CED4D4',
                                backgroundColor: '#fff',
                                borderTopLeftRadius: '10px',
                                borderRight: 'none',
                            }}>
                                <span className={styles.proactiveMsgsBoxHeading2}>INCOMING MESSAGES</span>
                                { pageFilter === ACQUIRE_CAMPAIGNS ? (
                                    <SortMenu
                                        sortBy={sortBy}
                                        orderBy={orderBy}
                                        onSortChange={onSortChange}
                                        pageFilter={pageFilter}
                                    />
                                ) : null }
                            </div>
                            <div className={styles.msgListContainer}>
                                <div className={styles.msgListInnerPuhcd}>
                                    <ProactiveMessageList
                                        source={source}
                                        organizationId={organizationId}
                                        msgList={messageList}
                                        selectedCheckboxes={selectedCheckboxes}
                                        setMessageLink={setMessageLink}
                                        setMessageSource={setMessageSource}
                                        loading={loading}
                                        channel={channel}
                                    />
                                </div>
                            </div>

                            <div className={styles.paginationContainer}>
                                <span className={'fustat-medium'}> {allMessagesCount ? `${messageCountStart} - ${messageCountEnd} of ${totalMsgsCount}` : ""}</span>
                                {totalPages > 1 &&
                                <div className="md-pagination numberless-pagination">
                                    <div className={styles.font14}>
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageClassName="page-item-none"
                                            pageCount={totalPages}
                                            marginPagesDisplayed={0}
                                            disableInitialCallback
                                            pageRangeDisplayed={2}
                                            forcePage={pageParams.currentPage}
                                            onPageChange={page => handlePageSelect(page)}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            breakClassName="page-item-none"
                                            previousClassName={`previous ${pageParams.currentPage === 0 ? "disabled" : ""}`}
                                            nextClassName={`next ${pageParams.currentPage === totalPages ? "disabled" : ""}`}
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={7} lg={7} sx={{width: '802px'}}>
                        <div className={styles.msgBoxRightContainer}>
                            <div className={styles.rightContainerHeading}>
                                <span className={styles.proactiveMsgsBoxHeading2}>CONVERSATION</span>
                            </div>
                            <div className={styles.msgListContainer}>
                                <div className={styles.rightMsgListInner}>
                                    {
                                        showCarousel ?
                                            <ConversationCarousel
                                                InAppContent={Content}
                                                message={conversationThread[0]}
                                                loading={loadingConversation}
                                                isScrollComplete={true}
                                                usePadding={true}
                                            /> :
                                            <Content />
                                    }

                                </div>
                            </div>

                            <div>
                                <div className={styles.viewSourceContainer}>
                                    {conversationThread?.length > 0 &&
                                    <a className="viewInSourceLink" target="_blank" rel="noreferrer noopener nofollow" href={messageLink}>
                                        View in <span className="viewInSourceLink text-transform-capitalize">{messageSource ? messageSource : 'source platform'}</span>
                                    </a>
                                    }
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Fragment>
    )
}
